import React from 'react'
import styled, { css } from 'styled-components'
import { FormElement as SingleSelectFormElement } from '@placeme/components/atoms/FormElement/FormElement'
import { TileFormParagraph, TitleFormSectionSubTitle, Checkbox } from '@dataplace.ai/ui-components/atoms'

import { MultiTilesField } from '@dataplace.ai/ui-components/molecules'

import { FormElement, FormFieldValue } from '../@types/IAttractivenessTileData'
import { COMPONENT_TYPES } from '../constants'

const GridWrapper = styled.div<{ grid: number }>(({ grid }) => css`
  display: grid;
  gap: 2rem;
  grid-template-columns: ${`repeat(${grid}, 1fr)`};
`)

const ElementBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const DashedWrapper = styled.div(({
  theme: {
    palette,
    corners,
  },
}) => css`
  display: flex;
  flex-direction: column;
  background: ${palette.light.white};
  border: 1.5px dashed ${palette.light.darkest};
  border-radius: ${corners.default.borderRadius};
  padding: 1rem;
`)

const StyledTitleFormSectionSubTitle = styled(TitleFormSectionSubTitle)`
  margin: 0;
`

const CheckboxWrapper = styled.div`
  display: flex;

  > div {
    > input[type='checkbox'], > input[type='checkbox'] + div {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`

interface AttractivenessFormElementWrapperProps {
  elements: FormElement[]
  setFormValue: (key: string, value: FormFieldValue) => void
  grid?: number
}

export const AttractivenessFormElementWrapper: React.FC<AttractivenessFormElementWrapperProps> = ({
  elements,
  setFormValue,
  grid = 1,
}) => (
  <GridWrapper grid={grid}>
    {elements.map(element => {
      const selectedValues = Array.isArray(element.formStateElement) ? element.formStateElement : []

      return (
        <ElementBlock key={element.inputKey}>
          {element.sectionTitle
            ? <StyledTitleFormSectionSubTitle>{element.sectionTitle}</StyledTitleFormSectionSubTitle>
            : null}
          {element.sectionDescription
            ? <TileFormParagraph>{element.sectionDescription}</TileFormParagraph>
            : null}

          {(() => {
            switch (element.componentType) {
              case COMPONENT_TYPES.CHECKBOX:
                return (
                  <CheckboxWrapper>
                    <Checkbox
                      checked={Boolean(element.formStateElement)}
                      label={element.title}
                      onChange={e => setFormValue(element.inputKey, e.target.checked)}
                    />
                  </CheckboxWrapper>
                )

              case COMPONENT_TYPES.DROPDOWN:
                return (
                  <DashedWrapper>
                    <SingleSelectFormElement
                      compact
                      dropdownWidth='8rem'
                      formStateElement={
                        Array.isArray(element.formStateElement)
                          ? ''
                          : element.formStateElement
                      }
                      inputKey={element.inputKey}
                      options={element.options}
                      setFormValue={(key, value) => setFormValue(key, value as FormFieldValue)}
                      title={element.title}
                    />
                  </DashedWrapper>
                )

              case COMPONENT_TYPES.MULTI_TILES:
                return (
                  <DashedWrapper>
                    <MultiTilesField
                      label={element.title}
                      onChange={(newValues) => setFormValue(element.inputKey, newValues)}
                      options={element.options}
                      values={selectedValues}
                    />
                  </DashedWrapper>
                )

              default:
                return null
            }
          })()}
        </ElementBlock>
      )
    })}
  </GridWrapper>
)
